module.exports = __webpack_public_path__ + "media/images/custom_bg-b842e188877e33d1fcf45d876c9ba713.jpg";